import script from "./ServicesSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesSettings.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./ServicesSettings.vue?vue&type=style&index=1&id=164e6fbb&lang=css"

const __exports__ = script;

export default __exports__